import {Action} from 'redux'
import {GeneralApplicationModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialQaulificationState: IQualificationState = {
  data: {
    applications: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface IQualificationState {
  data?: {
    applications?: GeneralApplicationModel[]
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IQualificationState = initialQaulificationState,
  action: ActionWithPayload<IQualificationState>
) => {
  switch (action.type) {
    //GET Qualification DATA
    case actionTypes.GET_GENERAL_APPLICATIONS_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_GENERAL_APPLICATIONS_LIST_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add Qualification SUB CATEGORY
    case actionTypes.ADD_GENERAL_APPLICATIONS_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_GENERAL_APPLICATIONS_LIST_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_GENERAL_APPLICATIONS_LIST_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update Qualification
    case actionTypes.UPDATE_GENERAL_APPLICATIONS_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_GENERAL_APPLICATIONS_LIST_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_GENERAL_APPLICATIONS_LIST_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_GENERAL_APPLICATIONS_LIST_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_GENERAL_APPLICATIONS_LIST_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_GENERAL_APPLICATIONS_LIST_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_GENERAL_APPLICATIONS_LIST_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_GENERAL_APPLICATIONS_LIST_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //SINGLE Enable
    case actionTypes.SINGLE_ACTIVATE_GENERAL_APPLICATIONS_LIST_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      const changedData: any = action.payload?.data?.applications
      let newData = state?.data?.applications?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, member: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_GENERAL_APPLICATIONS_LIST_REQUEST: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //SINGLE Disable
    case actionTypes.SINGLE_ACTIVATE_GENERAL_APPLICATIONS_LIST_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_GENERAL_APPLICATIONS_LIST_SUCCESS: {
      const changedData: any = action.payload?.data?.applications
      let newData = state?.data?.applications?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, member: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DEACTIVATE_GENERAL_APPLICATIONS_LIST_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    default:
      return state
  }
}
